export class Sector {
    id?: string;
    code: number;
    name: string;
    description: string;
    phoneNumber: string;
    always: boolean;

    constructor(sector) {
        if (sector.id) { this.id = sector.id; }
        this.code = sector.code;
        this.name = sector.name;
        this.description = sector.description;
        this.phoneNumber = sector.phoneNumber;
        this.always = sector.always;
    }
}
